import { useEffect, useState } from 'react'
import { useSceneStore } from '../../../../a.scenes/GameScene/store'
import { addEventListener, EVENTS_GAME, EVENTS_OBJECTS } from '../../../../b.providers/EventsProvider/EventsProvider'
import {
  SEL_SPELLS_BY_PLAYER,
  SEL_MANA_LEVEL_FOR_PLAYER,
  SEL_SET_SELECTED_SPELL,
  SEL_CLEAR_SELECTED_SPELL,
  SEL_NEXT_SPELLS_BY_PLAYER,
} from '../../../../c.managers/LevelManager/selectors'
import { COMMANDERS, Spell } from '../../../../c.managers/LevelManager/store.d'
import ManaIndicator from '../ManaIndicator/ManaIndicator'
import NextSpellCard from '../NextSpellCard/NextSpellCard'
import SpellCard from '../SpellCard/SpellCard'

const Deck = () => {
  const playerSpells = useSceneStore(SEL_SPELLS_BY_PLAYER(COMMANDERS.PLAYER))
  const playerNextSpell = useSceneStore(SEL_NEXT_SPELLS_BY_PLAYER(COMMANDERS.PLAYER))
  const selectSpellOnState = useSceneStore(SEL_SET_SELECTED_SPELL)
  const clearSpellOnState = useSceneStore(SEL_CLEAR_SELECTED_SPELL)

  const [selectedCardIndex, setSelectedCardIndex] = useState<number>(-1)
  const { manaLevel: availableMana } = useSceneStore(SEL_MANA_LEVEL_FOR_PLAYER)
  const setSpellSelected = (idx: number) => {
    setSelectedCardIndex(idx)
    if (idx === -1) {
      clearSpellOnState()
    } else {
      selectSpellOnState(idx)
    }
  }

  useEffect(() => {
    const unsub = addEventListener(EVENTS_OBJECTS.CAST_SPELL, ({ payload: Spell }) => {
      // on spell cast
      // deselect card
      setSelectedCardIndex(-1)
    })
    return () => unsub()
  }, [])
  return (
    <div className="deck-container">
      <div className="deck-upper-container">
        {playerNextSpell && <NextSpellCard dataIco={playerNextSpell.icon}>{playerNextSpell.name}</NextSpellCard>}
        {playerSpells.map((sc, idx) => (
          <SpellCard
            onSelect={() => {
              if (idx !== selectedCardIndex) {
                setSpellSelected(idx)
              } else {
                setSpellSelected(-1)
              }
            }}
            key={`spell_card_${sc.id}_${idx}`}
            dataIco={sc.icon}
            selected={idx === selectedCardIndex}
            disabled={(availableMana ?? 0) < sc.cost * 10}
            cost={sc.cost}
          >
            {sc.name}
          </SpellCard>
        ))}
        <div style={{ width: 40, backgroundColor: '#00ff00aa' }} />
      </div>
      <div className="deck-bottom-container">
        <ManaIndicator />
      </div>
    </div>
  )
}
export default Deck
